import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import {
  loadSessionState,
  saveSessionState,
} from '@src/app/_global/utility/persistedStorage';
import { rootReducer, rootEpic, RootState } from '@src/app/_redux';
// import { routerMiddleware } from 'react-router-redux';
// tslint:disable-next-line:no-submodule-imports
import createHistory from 'history/createBrowserHistory';

export const history = createHistory();
let initialState: any = loadSessionState();
const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const epicMiddleware = createEpicMiddleware();
// tslint:disable-next-line:no-shadowed-variable
function configureStore(initialState: any) {
  // configure middlewares
  // const middlewares = [createEpicMiddleware(rootEpic)];
  // compose enhancers
  const enhancer = composeEnhancers(applyMiddleware(epicMiddleware));
  const stores = createStore(rootReducer, initialState!, enhancer);
  epicMiddleware.run(rootEpic);
  // create store
  return stores;
}

// pass an optional param to rehydrate state on app start
const store = configureStore(initialState);
store.subscribe(() => {
  saveSessionState(store.getState());
});
// console.log('init state ', initialState);
// export store singleton instance
export default store;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store.ts